<template>
  <div
    class="PaymentStatus"
    v-if="orderInfo"
  >
    <div class="PaymentSuccess">
      <div class="payment-content">
        <img
          src="../../assets/images/updataFile/payment-success.png"
          class="success-icon"
          alt="支付成功"
          v-if="orderStart"
        >
        <img
          v-else
          src="../../assets/images/updataFile/payment-error.png"
          class="error-icon"
          alt="支付失败"
        >
        <div class="start">{{orderStart?'支付成功':'支付失败'}}</div>
        <div class="describe">{{orderStart?'请尽快与医护人员确认':'抱歉，您付款失败，请重新支付或咨询主治医师'}}</div>
        <div class="describe" v-if="orderStart&&tipsList.length>0" style="color:#1968a8;margin-top:10px;padding-left:20px;padding-right:20px;line-height:34px;">
          采样提醒：<span v-for="(item,index) in tipsList" :key="index" style="padding-right:10px">{{item.sampleSze}}</span>
        </div>
      </div>
      <div class="btn">
        <div
          class="complete"
          @click="goMyTesting"
          v-if="orderStart"
          style="margin:0 auto"
        >填写完成，进入采样</div>
        <div
          v-else
          class="return"
          @click="complete"
        >返回</div>
        <div
          class="againPayment"
          v-if="!orderStart"
          @click="againPayment(orderNo)"
        >重新支付</div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return {
      orderNo: "",
      orderInfo: false,
      orderStart: false,
      tipsList:[]
    };
  },
  created() {
    this.orderNo = this.$route.query.orderNo;
    this.openId = this.$route.query.openId;
    this.getOrder(this.orderNo);
    this.getOrderInfo(this.orderNo);
  },
  methods: {
    getOrderInfo(orderNo) {
      this.$http
        .get(`/blood-collection-tips/getByOrderNo/${orderNo}`)
        .then((res) => {
          if(res.data.code==200){
            let list =res.data.data;
            list.forEach(item => {
              if(item) this.tipsList.push(item)
            });
          }
        });
    },
    /**
     * 根据订单号查询是否支付成功
     */
    getOrder(orderNo) {
      this.$loading();
      this.$http
        .get(`/wechat/wxQueryOrder?outTradeNo=${orderNo}`)
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              this.$store.state.title = "支付成功";
              this.orderStart = true;
            } else {
              this.$store.state.title = "支付失败";
              this.orderStart = false;
            }
          } else {
            this.$store.state.title = "支付失败";
            this.orderStart = false;
          }
          this.$store.state.loadingFlag = false;
          this.orderInfo = true;
        })
        .catch((err) => {
          this.$toots("系统正在升级，请稍后");
          this.$store.state.title = "支付失败";
          this.orderStart = false;
          this.$store.state.loadingFlag = false;
          this.orderInfo = true;
        });
    },
    /**
     * 点击完成返回首页
     */
    complete() {
      this.$router.replace({
        name: "Index",
        query: {
          doctorId: localStorage.getItem("doctorId"),
          productTypeId: localStorage.getItem("productTypeId"),
        },
      });
    },
    goMyTesting() {
      this.$router.replace({
        name: "MyTesting",
      });
    },
    /**
     * 调用微信支付
     */
    againPayment() {
      this.$http
        .post(
          `/wechat/createOrder`,
          { orderNo: this.orderNo, openId: this.openId },
          { qs: "no" }
        )
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data;
            let nonceStr = data.nonceStr;
            let packageValue = data.packageValue;
            let paySign = data.paySign;
            let timeStamp = data.timeStamp;
            let signType = data.signType;
            this.wx.chooseWXPay({
              timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
              package: packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: paySign, // 支付签名
              success: (res) => {
                // 支付成功后的回调函数
                this.$store.state.loadingFlag = false;
                this.$store.state.closureFlag = true;
                this.$router.replace({
                  name: "PaymentSuccess",
                  query: {
                    orderNo: this.orderNo,
                    openId: this.openId,
                  },
                });
              },
              fail: (err) => {
                this.$toots("系统正在升级，请稍后");
              },
              cancel: (cancel) => {
                this.$toots("取消支付");
              },
            });
          } else if (res.data.code == 500) this.$toots(res.data.msg);
        })
        .catch((err) => {
          this.$toots("系统正在升级，请稍后");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.PaymentStatus {
  background-color: #fff;
  height: 100%;
  .PaymentSuccess {
    display: flex;
    flex-direction: column;
    .start {
      font-size: 34px !important;
    }
    .code {
      margin-top: 100px;
    }
    .code-list {
      width: 516px;
      padding-top: 44px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .item {
        width: 100px;
        height: 100px;
        font-size: 52px;
        font-weight: 700;
        text-align: center;
        line-height: 100px;
        border: 2px solid #1968a8;
        color: #1968a8;
      }
    }
    .btn {
      margin-bottom: 108px;
    }
  }
  .PaymentSuccess,
  .PaymentError {
    width: 100%;
    height: 100%;
    background-color: #fff;
    text-align: center;
    overflow: hidden;
    .success-icon,
    .error-icon {
      display: block;
      margin: 0 auto;
      margin-bottom: 50px;
      margin-top: 167px;
    }
    .success-icon {
      width: 168px;
      height: 170px;
    }
    .error-icon {
      width: 171px;
      height: 172px;
    }
    .start {
      font-size: 40px;
      font-weight: 700;
    }
    .describe {
      margin-top: 10px;
      font-size: 30px;
      color: #999999;
    }
    .btn {
      display: flex;
      justify-content: space-between;
      padding-left: 100px;
      padding-right: 100px;
      margin-top: 79px;
      > .return,
      .againPayment {
        width: 260px;
        height: 80px;
        line-height: 80px;
        border-radius: 8px;
        font-size: 32px;
        border: 1px solid #1968a8;
      }
      .return {
        color: #1968a8;
      }
      .againPayment {
        background-color: #1968a8;
        color: #fff;
      }
      .complete {
        padding-left: 110px;
        padding-right: 110px;
        height: 80px;
        line-height: 80px;
        border-radius: 8px;
        background-color: #1968a8;
        font-size: 32px;
        color: #fff;
      }
    }
  }
}
</style>


